import type { ViewerProductPermissions } from '@hopdrive/feature-portal-products';

/**
 * The synthetic hash session's grant set (decision A1 in `embed-customization-decisions.md`):
 * every feature the dealer's product routes gate on. Absent on purpose: invoices,
 * user-management, dispatching, dispatching-rideshare — the embed has no route for any of them.
 *
 * The embed's session is a hash, not a login: there is no permission store to read, so the grants
 * are a constant and every feature gate below is effectively open (decision A6).
 */
export const EMBED_GRANTED_FEATURES: ReadonlySet<string> = new Set([
  'planning',
  'mobile-service',
  'parts-delivery',
  'appraisals',
  'guestrides',
  'driver-management',
]);

/**
 * The four permission facts the products composition runs on. A module constant so its identity
 * is stable across renders — the package's re-derive effect depends on it.
 */
export const EMBED_PRODUCT_PERMISSIONS: ViewerProductPermissions = {
  canPlanMoves: true,
  hasMobileServiceAccess: true,
  hasPartsDeliveryAccess: true,
  hasAppraisalsAccess: true,
};
